// Run this example by adding <%= javascript_pack_tag 'hello_react' %> to the head of your layout file,
// like app/views/layouts/application.html.erb. All it does is render <div>Hello React</div> at the bottom
// of the page.

import React from 'react'
import Intro from './sections/intro.jsx'
import Bio from './sections/bio.jsx'
import Skills from './sections/skills.jsx'
import Projects from './sections/projects.jsx'
import Resume from './sections/resume.jsx'
import Contact from './sections/contact.jsx'

class App extends React.Component {

  scrollToSection = (e)=>{
    document.getElementById(e.target.name).scrollIntoView({behavior: "smooth"})
  }

  addObserver = (ref)=>{  
    let observer = new IntersectionObserver((entries, observer)=>{
      console.dir(entries)
      entries.forEach((entry)=>{
        if (entry.isIntersecting > 0.5) {
          console.log(entry.target.id)
          let navBtnCollection = document.querySelectorAll(`[data-name*="nav_btn"]`)
          navBtnCollection.forEach((btn)=>{
            if (btn.attributes.name.value === entry.target.id){
              btn.attributes.class.value = btn.attributes.class.value += ` bg-green-500`
            }
            else {
              btn.attributes.class.value = btn.attributes.class.value.replace(" bg-green-500", "")
            }
          })
        } 
      },[])
    })
    observer.observe(ref)
  }
  
  render() {
    return (
      <div className="max-w-viewport">
        <Intro scrollToSection={this.scrollToSection}/>
        <div className="bg-cover bg-gradient-to-r from-gray-900 to-gray-800 -pt-20">
          <div className="less-than-lg:hidden lg:block sticky container text-white text-center bg-black mr-12 -mt-100 w-20 top-10 float-right font-bold">
            <div data-name="nav_btn" name="bio" className="w-20 h-20 py-6 hover:bg-green-500" onClick={()=>document.getElementById("bio").scrollIntoView({behavior: "smooth"})}>Bio</div>
            <div data-name="nav_btn" name="skills" className="w-20 h-20 py-6 hover:bg-green-500" onClick={()=>document.getElementById("skills").scrollIntoView({behavior: "smooth"})}>Skills</div>
            <div data-name="nav_btn" name="projects" className="w-20 h-20 py-6 hover:bg-green-500" onClick={()=>document.getElementById("projects").scrollIntoView({behavior: "smooth"})}>Projects</div>
            <div data-name="nav_btn" name="resume" className="w-20 h-20 py-6 hover:bg-green-500" onClick={()=>document.getElementById("resume").scrollIntoView({behavior: "smooth"})}>Resume</div>
            <div data-name="nav_btn" name="contact" className="w-20 h-20 py-6 hover:bg-green-500" onClick={()=>document.getElementById("contact").scrollIntoView({behavior: "smooth"})}>Contact</div>
          </div>
          <Bio attach={this.addObserver} />
          <Skills attach={this.addObserver}/>
          <Projects attach={this.addObserver}/>
          <Resume attach={this.addObserver} />
          <Contact attach={this.addObserver}/>
        </div>
      </div>
    )
  }
}

export default App;
